import React, { Component } from 'react';

import '../css/App.css';
import '../css/fonts.css';
import '../css/addlightness.css';

/*
import cloud1 from '../img/cloud1.png'
import cloud2 from '../img/cloud2.png'
import cloud3 from '../img/cloud3.png'
*/

//import history from '../history';


export class WebWritings extends Component {
  constructor(props) {
    super(props)

    this.EXPANDED_FONT_SIZE = 60
    this.NORMAL_FONT_SIZE = 34
    this.MAX_FONT_DIFF = this.EXPANDED_FONT_SIZE - this.NORMAL_FONT_SIZE

    this.ANIM_DECREMENT = 0.08
    this.ANIM_STEPS = 1.0 / this.ANIM_DECREMENT
    this.ANIM_INTERVAL_MS = 15
    this.ANIM_DURATION = this.ANIM_STEPS * this.ANIM_INTERVAL_MS


    this.state = {
      animWasTriggered: false,
      animInProgress: false,
      animPct: 1.0,
      animStartTime: null,
      animElapsed: 0,
      showDescBox: false,
    }

    this.animIntervalId = null;

    this.startAnimation = this.startAnimation.bind(this)
    this.stopAnimation = this.stopAnimation.bind(this)
    this.doAnimInterval = this.doAnimInterval.bind(this)

    this.hovered = this.hovered.bind(this)
    this.unHovered = this.unHovered.bind(this)

    this.getDivStyle = this.getDivStyle.bind(this)
    this.renderDescriptionBox = this.renderDescriptionBox.bind(this)
  }


  hovered(elem) {
    //console.log("hovered() for id: " + elem.target.id)

    const triggers = [ "web-writings-parent", "web-writings-anchor" ]
    if ( triggers.includes(elem.target.id) ) {
      if ( ! this.state.animWasTriggered ) {
        this.props.blurFunc("web-writings")
        this.startAnimation()
      }
    }
  }


  unHovered(elem) {
    //console.log("unHovered() for elem: "+ elem.target.id)
    if ( elem.target.id === "web-writings-parent" ) {
      //console.log("web-writings-parent unHovered")
      this.props.unBlurFunc()
      this.stopAnimation()
      this.setState({
        animWasTriggered: false,
        showDescBox: false,
      })
    }
  }


  doAnimInterval() {
    //console.log("doAnimInterval() id: " + this.animIntervalId + " elapsed: " + this.state.animElapsed + " duration: " + this.ANIM_DURATION)

    if ( this.state.animElapsed >= this.ANIM_DURATION ) {
      //console.log("animPct <= 0")
      this.stopAnimation()
    } else {
      // issues with when number gets close to 0. Maybe a JS float problem.
      let newPct = this.state.animPct - this.ANIM_DECREMENT
      let newElapsedTime = this.state.animElapsed + this.ANIM_INTERVAL_MS
      if ( newPct < 0.01 ) {
        newPct = 0.0
      }
      //console.log(`animation interval decremented animPct: ${newPct}`)
      this.setState({
        animPct: newPct,
        animElapsed: newElapsedTime,
      })
    }
  }

  startAnimation() {
    if ( ! this.state.animWasTriggered ) {
      //console.log("startAnimation() with duration: " + this.ANIM_DURATION)

      this.animIntervalId = setInterval(() =>
        this.doAnimInterval(),
        this.ANIM_INTERVAL_MS
      )

      this.setState({
        animWasTriggered: true,
        animInProgress: true,
        animStartTime: Date.now(),
      })
    }
  }

  stopAnimation(elem) {
    //console.log("stopAnimation() for animIntervalId: " + this.animIntervalId)

    clearInterval(this.animIntervalId)

    this.setState({
      animInProgress: false,
      animStartTime: null,
      animElapsed: 0,
      animPct: 1.0,
      showDescBox: true,
    })
  }

  getDivStyle() {
    let fontSize = this.NORMAL_FONT_SIZE

    if ( this.state.animInProgress ) {
      const currentDiffSize = this.MAX_FONT_DIFF * ( 1 - this.state.animPct )
      //console.log("animating with currentDiffSize: " + currentDiffSize)
      fontSize = this.NORMAL_FONT_SIZE + currentDiffSize
      //console.log("animating with fontSize: " + fontSize)
    } else if ( this.state.animWasTriggered  ) {
      fontSize = this.EXPANDED_FONT_SIZE
    }

    let elementStyle = {}
    Object.assign(elementStyle, this.props.unBlurredStyle)
    elementStyle.fontSize = `${fontSize}px`

    return elementStyle
  }

  renderDescriptionBox() {
    const description = `
      Some observations about SQA, management, development, and life on Spaceship Earth.
      `

    return (
      <div className="app-description-box">
        { description }
      </div>
    )
  }

  render() {

    let anchorStyle = {}
    let divStyle = this.props.unBlurredStyle
    if ( this.state.animWasTriggered ) {
      divStyle = this.getDivStyle()
    } else if ( this.props.whichBoxWasTriggered !== "none" ) {
      anchorStyle = this.props.anchorBlurredStyle
      divStyle = this.props.blurredStyle
    }

    anchorStyle = this.props.anchorBlurredStyle
    divStyle = this.props.unBlurredStyle


    return (
      <div>
        <div
          style={divStyle}
          id="web-writings-parent"

          onMouseOver={ this.hovered }
          onMouseLeave={ this.unHovered }
        >
          <a
            id="web-writings-anchor"
            style={anchorStyle}
            href="http://seanfelipe.github.io">
            Web Writings
          </a>
        </div>
        <div>
          { this.state.showDescBox
              ? this.renderDescriptionBox()
              : null
          }
        </div>
      </div>
    )
  }
}
